// EditJob — modal-embedded form for updating a Job row.
// Refactored 2026-05-05 (Phase 3.3, Class P) onto ModalFormHeader.

import React, { useState } from "react";
import CTextField from "../CTextField/CTextField";
import { Button, Stack, Box } from "@mui/material";
import { WorkOutlineRounded } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import CSelect from "../CSelect/CSelect";
import { updateJob } from "../../feature/jobSlice";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { showErrorToast, showSuccessToast } from "../../utils/Toast";
import { ModalFormHeader, FieldLabel } from "../PaperForm";
import { JOB_STATUS_OPTIONS } from "../../utils/jobStatus";

const EditJob = (props) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({
    id: props.data.id,
    name: props.data.name,
    description: props.data.description,
    totalTasks: props.data.totalTasks ? props.data.totalTasks : 0,
    completedTasks: props.data.completedTasks ? props.data.completedTasks : 0,
  });

  const [status, setSelectedStatus] = React.useState(props.data.status);
  const [startDate, setJobStartDate] = useState(dayjs(props.data.startDate));
  const [endDate, setJobEndDate] = useState(
    props.data.endDate ? dayjs(props.data.endDate) : ""
  );

  // Form parity 2026-09-29: production jobs.status is enum('in_process','completed',
  // 'priority'); "On Hold" was offered but MySQL rejected it. Same list as AddJob and iPad.
  const selectData = JOB_STATUS_OPTIONS;

  const handleChange = (event) => {
    setData((prv) => ({ ...prv, [event.target.name]: event.target.value }));
  };

  const handleSubmit = () => {
    let finalData = { status, startDate, endDate, ...data };
    dispatch(updateJob(finalData)).then((res) => {
      if (res.type === "updateJobs/jobs/fulfilled") {
        const { message } = res.payload;
        showSuccessToast(message);
        props.setOpen(false);
      }
      if (res.type === "updateJobs/jobs/rejected") {
        const { message } = res.error;
        showErrorToast(message);
      }
    });
  };

  return (
    <Box>
      <ModalFormHeader
        overline="SFM · Job"
        title="Edit Job"
        icon={WorkOutlineRounded}
      />
      <Stack spacing={2}>
        <CTextField
          margin="0px"
          defaultValue={data.name}
          onChange={handleChange}
          name="name"
          label="Job name"
        />
        <CTextField
          margin="0px"
          defaultValue={data.description}
          onChange={handleChange}
          name="description"
          label="Description"
        />
        <Box>
          <FieldLabel>Status</FieldLabel>
          <CSelect
            label=""
            margin="0px"
            padding="0px"
            data={selectData}
            initialValue={status}
            setinitialValue={setSelectedStatus}
          />
        </Box>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DatePicker"]}>
            <Stack direction="column" spacing={2} sx={{ width: "100%" }}>
              <DatePicker
                label="Start Date"
                value={startDate}
                onChange={(newValue) => setJobStartDate(newValue)}
              />
              <DatePicker
                label="End Date"
                value={endDate}
                onChange={(newValue) => setJobEndDate(newValue)}
              />
            </Stack>
          </DemoContainer>
        </LocalizationProvider>
        <Button
          disabled={props.isLoading}
          onClick={handleSubmit}
          variant="contained"
          sx={{
            width: "100%",
            mt: 1,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            letterSpacing: "0.01em",
          }}
        >
          {props.isLoading ? "Loading…" : "Save changes"}
        </Button>
      </Stack>
    </Box>
  );
};

export default EditJob;
